import Button from "devextreme-react/button";
import { useContext } from "react";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { LoadPagePanel } from "../../../../components";
import { AR, FileTypes, OrderStatus } from "../../../../types/enums";
import { showErrorMessage, showSuccessMessage } from "../../../../utils/messages";
import { useSubmitWOC } from "../api/submit-woc";
import { WorkOrderContext } from "../context/WorkOrderContext";

export default function SubmitWOCButton() {

	const { order, refetchOrder } = useContext(WorkOrderContext);

	const navigate = useNavigate();
	const location = useLocation();

	const [searchParams] = useSearchParams();
	const returnUrl = encodeURIComponent(searchParams.get("returnUrl") ?? "");

	const submitWOC = useSubmitWOC(
		order.details.workOrderID,
		(result) => {
			showSuccessMessage('WOC has been submitted');
			refetchOrder()
				.then(() => {
					const newActionRequiredID = result.activeARs[0];

					const to = `/cfi/work-order/${order.details.workOrderID}/${newActionRequiredID}` +
						(!!returnUrl ? '?returnUrl=' + returnUrl : '');

					if (newActionRequiredID && location.pathname !== to) {
						navigate(to);
					}
				});
		},
		(error) => showErrorMessage(error)
	);

	return (
		<>
			<Button
				text="Submit WOC"
				icon="Inscyth-Confirm"
				visible={order.details.activeARs.includes(AR.WOCfiToUploadWOC)}
				disabled={order.details.orderStatusID === OrderStatus.Pending || submitWOC.isLoading ||
					!order.details.files.find(x => x.fileTypeID === FileTypes.WOC)}
				onClick={() => {
					submitWOC.mutate();
				}} >
			</Button>
			<LoadPagePanel visible={submitWOC.isLoading}></LoadPagePanel>
		</>
	)
}
